import useAKBStore from '@/pages/AKB/AKB.store.ts';
import useSandboxStore from '@/modules/Sandbox/Sandbox.store.ts';
import useDesignerStore from '@/pages/Designer/Designer.store.ts';
import useConversationStore from '@/pages/Conversations/Conversations.store.ts';
import useWorkflowStore from '@/pages/Workflow/Workflow.store.ts';
import useDesignerFilesStore from '@/pages/Project/components/Files/DesignerFiles.store';
import { gcsClient } from '@/utils/api/gcsClient.service';

export const flushLocalCustomerData = () => {
    useAKBStore.getState().flush();
    useSandboxStore.getState().flush();
    useDesignerStore.getState().flush();
    useConversationStore.getState().flush();
    useWorkflowStore.getState().flush();
    useDesignerFilesStore.getState().flush();
    gcsClient.reset();
};
